/// <reference path="./Tag.ts" />
namespace HA.Core.HTML {
    //noinspection TsLint
    export class P extends Tag {
        public getTagName():string {
            return "p";
        }
    }
}
